import { AppShell } from '@mantine/core';
import { useIdle } from '@mantine/hooks';
import { ModalsProvider } from '@mantine/modals';
import { useQueryClient } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { DialogProvider } from '../../../../react-commons/dialog-provider/DialogProvider';
import {
    removeAllDockedDialogs,
    removeAllFileUploadTask,
    setImportingOrExportingState,
    setOpenSpinnerState,
} from '../../persisted/global/globalActions';
import { useShowSystemAnnouncements } from '../hooks/useShowSystemAnnouncements';
import { setIdle } from '../ui-state/local-status/localStatusActions';
import { StatusComponent } from './global/status/StatusComponent';
import { MenuBarComponent } from './global/menubar/MenuBarComponent';
import { StatusBarComponent } from './global/status/StatusBarComponent';
import { RouteValidatorComponent } from '../router/RouteValidatorComponent';


const ApplicationHooks = () => {
    useShowSystemAnnouncements();
    useShowSystemAnnouncements();

    return <></>;
};

export const ApplicationShell = () => {
    const qc = useQueryClient();

    const isIdle = useIdle(60000, { initialState: false });
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setIdle(isIdle));
    }, [isIdle, dispatch]);

    React.useEffect(() => {
        dispatch(setImportingOrExportingState(false));
        dispatch(setOpenSpinnerState(false));
        dispatch(removeAllFileUploadTask());
        dispatch(removeAllDockedDialogs());
    }, [dispatch]);

    React.useEffect(() => {
        qc.setDefaultOptions({
            queries: {
                staleTime: 5000,
                refetchInterval: 15000,
                retry: false,
                enabled: !isIdle,
            },
        });
    }, [isIdle, qc.setDefaultOptions]);

    return (
        <DialogProvider>
            <ModalsProvider modalProps={{ zIndex: 2900 }}>
                <div className={'window-root'} style={{ paddingBottom: '25px' }}>
                    <AppShell header={{ height: 40 }} footer={{ height: 20 }} style={{ height: '100%' }}>
                        <AppShell.Header>
                            <MenuBarComponent />
                        </AppShell.Header>
                        <AppShell.Main style={{ height: '100%' }}>
                            <RouteValidatorComponent>
                                <Outlet />
                            </RouteValidatorComponent>
                        </AppShell.Main>
                        <AppShell.Footer>
                            <StatusBarComponent />
                        </AppShell.Footer>
                    </AppShell>
                    <StatusComponent />
                    <ApplicationHooks />
                </div>
            </ModalsProvider>
        </DialogProvider>
    );
};
